import { useEffect } from 'react'
import { ContentStateInterface } from '../../../../../../@types/types'
import { useAppDispatch } from '../../../../../../app/hooks'
import { fetchRentValuationDebounced } from '../../../../../../redux/thunks/valuation/fetchRentValuationIfReady'

export function useLoadRentValuationData(insertionData: ContentStateInterface, enabled: boolean = true) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!enabled) {
      return
    }

    dispatch(fetchRentValuationDebounced())
  }, [
    enabled,
    insertionData.street,
    insertionData.city,
    insertionData.houseNumber,
    insertionData.postcode,
    insertionData.livingSpace,
    insertionData.room,
    dispatch,
  ])
}
